// extracted by mini-css-extract-plugin
module.exports = {"section":"section_section__1v_U4","name":"section_name__1Uo3a","post":"section_post__3Gpon","title":"section_title__3dWV5","text":"section_text__F_fKt"};